/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { colors } from '../../shared/theme/colors'
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography';
import { ticketColors } from '../../shared/theme/ticketColors';

type Props = {
  selectedCount: number;
  canActivate?: boolean;
  onActivateAll: () => void;
  onDeactivateAll: () => void;
  onClear: () => void;
  onExit: () => void;
};

export function PromotionsBatchBar({ selectedCount, canActivate = true, onActivateAll, onDeactivateAll, onClear, onExit }: Props) {
  if (selectedCount === 0) {
    return (
      <View style={styles.container}>
        <Text style={styles.hint}>Seleccioná promos para activar o desactivar.</Text>
        <TouchableOpacity onPress={onExit} accessibilityRole="button" accessibilityLabel="Salir selección">
          <Ionicons name="close" size={20} color={ticketColors.ink2} />
        </TouchableOpacity>
      </View>
    );
  }

  return (
    <View style={styles.container}>
      <Text style={styles.count}>{selectedCount} seleccionada{selectedCount === 1 ? '' : 's'}</Text>
      <View style={styles.actions}>
        <TouchableOpacity
          style={[styles.actionBtn, !canActivate && styles.actionBtnDisabled]}
          onPress={canActivate ? onActivateAll : undefined}
          disabled={!canActivate}
          accessibilityRole="button"
          accessibilityLabel="Activar seleccionadas"
        >
          <Ionicons name="checkmark-circle-outline" size={16} color={canActivate ? ticketColors.gold : ticketColors.ink2} />
          <Text style={[styles.actionText, !canActivate && styles.actionTextDisabled]}>Activar</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.actionBtn, !canActivate && styles.actionBtnDisabled]}
          onPress={canActivate ? onDeactivateAll : undefined}
          disabled={!canActivate}
          accessibilityRole="button"
          accessibilityLabel="Desactivar seleccionadas"
        >
          <Ionicons name="close-circle-outline" size={16} color={canActivate ? colors.warning : ticketColors.ink2} />
          <Text style={[styles.actionText, !canActivate && styles.actionTextDisabled]}>Desactivar</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.actionBtn}
          onPress={onClear}
          accessibilityRole="button"
          accessibilityLabel="Limpiar selección"
        >
          <Ionicons name="remove-circle-outline" size={16} color={ticketColors.ink2} />
          <Text style={styles.actionText}>Limpiar</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.exitBtn}
          onPress={onExit}
          accessibilityRole="button"
          accessibilityLabel="Salir selección"
        >
          <Ionicons name="close" size={20} color={ticketColors.ink2} />
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    backgroundColor: ticketColors.paper2,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 10,
    marginBottom: spacing.sm,
  },
  hint: {
    ...typography.body,
    color: ticketColors.ink2,
    fontWeight: '600',
  },
  count: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '800',
  },
  actions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.sm,
  },
  actionBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
  },
  actionText: {
    ...typography.caption,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  actionBtnDisabled: {
    opacity: 0.4,
  },
  actionTextDisabled: {
    color: ticketColors.ink2,
  },
  exitBtn: {
    padding: 4,
  },
});
